import { render, staticRenderFns } from "./ClientOrders.vue?vue&type=template&id=fae77480"
import script from "./ClientOrders.vue?vue&type=script&lang=js"
export * from "./ClientOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports